if (!window.tocScriptInitialized) {
  window.tocScriptInitialized = true;

  document.addEventListener('DOMContentLoaded', function () {
    const tableOfContentsBlock = document.querySelector('.table-contents')
    const tocElement = document.querySelector('.r-table-of-contents');
    if(tableOfContentsBlock) {
      const toggler = tableOfContentsBlock.querySelector('.r-title')
      toggler.addEventListener('click', (e) => {
        e.target.classList.toggle('hidden')
        tocElement.classList.toggle('hidden')
      })
    }

    if (typeof tocData !== 'undefined') {

      // Assign IDs to headings in .r-content by index
      const contentElement = document.querySelector('.r-content');
      if (contentElement) {
        tocData.forEach((item, index) => {
          // Find the heading in the .r-content by index and tag name
          const headings = Array.from(contentElement.querySelectorAll(item.tagName));

          if (headings[index]) {
            headings[index].id = item.id; // Assign the ID from tocData
          }
        });
      }


      if (tocElement) {
        const ul = document.createElement('ul');

        tocData.forEach(item => {
          const li = document.createElement('li');
          li.innerHTML = `<a href="#${item.id}">${item.textContent}</a>`;
          ul.append(li)

        });
        tocElement.append(ul)


        // Add smooth scroll event listener
        tocElement.querySelectorAll('a').forEach(anchor => {
          anchor.addEventListener('click', function(e) {
            e.preventDefault();
            const targetId = this.getAttribute('href').substring(1);
            const targetElement = document.getElementById(targetId);
            if (targetElement) {
              targetElement.scrollIntoView({ behavior: 'smooth' });
            }
          });
        });
      }
    }
  });
}